export default __webpack_public_path__ + "static/media/background2.f7d20bf9.jpg";